import { render, staticRenderFns } from "./ReasonList.vue?vue&type=template&id=1ce0206f&scoped=true"
import script from "./ReasonList.vue?vue&type=script&lang=js"
export * from "./ReasonList.vue?vue&type=script&lang=js"
import style0 from "./ReasonList.vue?vue&type=style&index=0&id=1ce0206f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0206f",
  null
  
)

export default component.exports